import React from "react";

import JosefSoriano from "../../../assets/images/directors/josef-soriano.png";
import LeaSoriano from "../../../assets/images/directors/lea-soriano.png";
import DefaultImage from "../../../assets/images/default-avatar-photo-placeholder-profile-picture-vector.jpg";

const BROC = () => {
  return (
    <div id='chartListContainer'>
      <ul className='main-list'>
        <li className='list-item main'>
          <div className='image-container'>
            <img src={JosefSoriano} alt='josef-soriano' />
          </div>
          <div className='text-container'>
            <div className='name'>Josef Ryan Y. Soriano</div>
            <div className='title'>Chairman</div>
          </div>
        </li>
      </ul>
      <ul className='sub-list'>
        <li className='list-item'>
          <div className='image-container'>
            <img src={LeaSoriano} alt='lea-soriano' />
          </div>
          <div className='text-container'>
            <div className='name'>Lea S. Soriano</div>
            <div className='title'>Member</div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default BROC;
